import { GoogleTagManager } from '@next/third-parties/google';
import Head from 'next/head';
import Scripts from 'src/Scripts';

import DefaultTemplate from './templates/DefaultTemplate';
import { RouteHandlerReturn } from './types/model';

const Layout = ({ routeData }: { routeData: RouteHandlerReturn }): JSX.Element => {
  const gtmId = routeData.props?.globalSettings?.googleTagManagerId || '';

  return (
    <>
      <Scripts />
      <Head>
        <title>{routeData.props?.route.slug || 'Page'}</title>
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <GoogleTagManager gtmId={gtmId} />
      {routeData && <DefaultTemplate routeData={routeData} />}
    </>
  );
};

export default Layout;
